import { endlessPaginate } from "endless_pagination/endless-pagination-module.js";
import { MovieGLightbox } from "../../common/image_gallery.js";

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	endlessPaginate();

	const gallery_data = document.querySelector("#_gallery-section");
	if (gallery_data) {
		new MovieGLightbox({
			url: `/misc/immagini/${gallery_data.dataset.ct}/${gallery_data.dataset.id}/`,
			per_page: 20,
			selector: gallery_data.dataset.gallerySelector,
		});
	}
});
